import apiClient from '@/services/axios'

export async function post(budget) {
  var response = await apiClient.post('/ActivationPlanBudgets/', budget)
  if (response) {
    return response.data
  }

  throw new Error('Unable to set budget.')
}